import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Modal from "react-modal";
import PaymentLinkTable from "../PaymentLinkTable";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import PartialPaymentsMobile from "./PartialPaymentsMobile";
import { convertThenFormat } from "../../common-data/Converts";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import OnlineCashCollect from "./online-cash-partial-payments/OnlineCashCollect";

const PartialDetailsTable = ({
  allPaymentData,
  setAllPaymentData,
  decryptedText,
  callFunction,
}) => {
  const { loading } = useSelector((state) => state.api);

  const { isPage, pagination, allPaymentInfoData } = allPaymentData || {};
  const initialPMInfo = {
    partialModal: false,
    partialInfo: [],
    rowData: "",
  };
  const [pmDetails, setPMDetails] = useState(initialPMInfo);

  const onOnclickPM = (detail, row) => {
    if (detail?.length > 0) {
      setPMDetails({
        partialModal: true,
        partialInfo: detail,
        rowData: row,
      });
    } else {
      toast.error("No Detail Found!");
    }
  };

  const tbColumns = [
    {
      dataField: "name",
      text: "name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.name || "NA"}</span>;
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "price",
      text: "Amount",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">₹{convertThenFormat(row?.price || 0)}</span>
        );
      },
    },
    {
      dataField: "price",
      text: "Payment Status",
      formatter: (cell, row) => {
        const totalPendings =
          row?.partial_payment?.length > 0 &&
          row.partial_payment.filter((val) => val?.status === "pending").length;
        return (
          <span
            className="tb-data hoverBlue"
            style={{
              textDecoration: "underline",
              fontWeight: "700",
              color: "#5F5DF0",
            }}
            onClick={() =>
              onOnclickPM(row?.partial_payment, row)
            }>{`${totalPendings} Pending`}</span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={pmDetails.partialModal}
        onRequestClose={() => setPMDetails(initialPMInfo)}
        contentLabel="Partial Payment Details Modal"
        ariaHideApp={false}>
        <div className="createNewCTOModalContainer paymentDetailsModalContainer">
          <ModalHeadAndClose
            title="Payment Details"
            onClose={() => setPMDetails(initialPMInfo)}
          />

          <OnlineCashCollect
            tbData={pmDetails.partialInfo}
            userInfoData={decryptedText}
            callFunction={() => {
              callFunction();
              setPMDetails(initialPMInfo);
            }}
          />
        </div>
      </Modal>

      <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allPaymentInfoData}
            tableColumns={tbColumns}
            tablePagination={pagination}
            isPage={isPage}
            setIsPage={(value) =>
              setAllPaymentData((prevData) => ({
                ...prevData,
                isPage: value,
              }))
            }
          />
        )}
      </div>

      <div className="lead-logs-card-container only-mobile">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PartialPaymentsMobile
            tableData={allPaymentInfoData}
            tablePagination={pagination}
            isPage={isPage}
            setIsPage={(value) =>
              setAllPaymentData((prevData) => ({
                ...prevData,
                isPage: value,
              }))
            }
            onOnclickPM={onOnclickPM}
          />
        )}
      </div>
    </>
  );
};

export default PartialDetailsTable;
